const prefix = "mainTree";

export const _sharedActionsConstantsMainTree = {
  FETCH_FOLDERS_TO_ROOT_SUCCESS: prefix + "FETCH_FOLDERS_TO_ROOT_SUCCESS",
  FETCH_MAIN_TREE_SUCCESS: prefix + "FETCH_MAIN_TREE_SUCCESS",
  FETCH_BIBLES_SUCCESS: prefix + "FETCH_BIBLES_SUCCESS",
  FETCH_SG_BOOKS_SUCCESS: prefix + "FETCH_SG_BOOKS_SUCCESS",
  FETCH_DICTIONARIES_SUCCESS: prefix + "FETCH_DICTIONARIES_SUCCESS",

  FETCH_LANGUAGE_FOLDERS: prefix + "FETCH_LANGUAGE_FOLDERS",


  SET_BOOKS: prefix + "SET_BOOKS",
  PUSH_BOOKS: prefix + "PUSH_BOOKS",
  FETCH_BOOK: prefix + "FETCH_BOOK",
  ADD_ID_BOOK_FETCH_FAILED: prefix + "ADD_ID_BOOK_FETCH_FAILED",
  FETCH_BOOKS_BY_IDS: prefix + "FETCH_BOOKS_BY_IDS",
};

export const _sharedActionsMainTree = {
  fetchFoldersToRootSuccess: (data, options = {}) => ({
    type: _sharedActionsConstantsMainTree.FETCH_FOLDERS_TO_ROOT_SUCCESS,
    data: {
      mainTree: data,
      options,
    },
  }),
  fetchMainTreeSuccess: (data) => ({
    type: _sharedActionsConstantsMainTree.FETCH_MAIN_TREE_SUCCESS,
    data
  }),
  fetchBiblesSuccess: (data) => ({
    type: _sharedActionsConstantsMainTree.FETCH_BIBLES_SUCCESS,
    data,
  }),
  fetchSGBooksSuccess: (data) => ({
    type: _sharedActionsConstantsMainTree.FETCH_SG_BOOKS_SUCCESS,
    data
  }),
  fetchDictionariesSuccess: (data) => ({
    type: _sharedActionsConstantsMainTree.FETCH_DICTIONARIES_SUCCESS,
    data
  }),
  fetchLanguageFolders: (lang) => ({
    type: _sharedActionsConstantsMainTree.FETCH_LANGUAGE_FOLDERS,
    data: lang,
  }),

  setBooks: (data) => ({
    type: _sharedActionsConstantsMainTree.SET_BOOKS,
    data,
  }),
  addBooks: (books) => ({
    type: _sharedActionsConstantsMainTree.PUSH_BOOKS,
    data: books,
  }),
  fetchBook: (nBookId) => ({
    type: _sharedActionsConstantsMainTree.FETCH_BOOK,
    data: nBookId,
  }),
  fetchBooksByIds: (booksIds, loaderId) => ({
    type: _sharedActionsConstantsMainTree.FETCH_BOOKS_BY_IDS,
    data: { booksIds, loaderId }
  }),
  addIdBrokenBook: (id) => ({
    type: _sharedActionsConstantsMainTree.ADD_ID_BOOK_FETCH_FAILED,
    data: id,
  }),
};
